module.exports = __webpack_public_path__ + "01_short_gold.c2ae32ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_short_gold.png
// module id = 3w8S
// module chunks = 0